import { useMemo } from 'react';
import { ROUTE_NAMES } from '@atlassian/jira-common-constants/src/spa-routes';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils';

export const useIsJSMBoard = () => {
	const { name } = useCurrentRoute();

	return useMemo(() => name === ROUTE_NAMES.SERVICEDESK_BOARDS, [name]);
};
